import { render, staticRenderFns } from "./FamilyWholesaleDiscountsCreate.vue?vue&type=template&id=33b9db9e&lang=pug&"
import script from "./FamilyWholesaleDiscountsCreate.vue?vue&type=script&lang=js&"
export * from "./FamilyWholesaleDiscountsCreate.vue?vue&type=script&lang=js&"
import style0 from "./FamilyWholesaleDiscountsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FamilyWholesaleDiscountsCreate.vue"
export default component.exports